import React from "react";

import UseCasesPageTemplate from "../../components/global/layout/UseCasesPageTemplate";
import { workflow } from "../../constants/productPageData";
import { mediaQueries } from "../../constants/mediaQueries";


const Workflow = ({ location }) => {

    const imageSettings = [
        {
            id: 1,
            location: "left",
            coloursObj: {
                triangleColour: "#F59E0B",
                backgroundColor: "#FCD34D",
            },
            trianglePosition: "bottom-right",
            axisMultipliers: {
                x: 0.3,
                y: 0.1,
            },
            styles: {
                position: "absolute",
                maxWidth: "768px",
                top: 40,
                right: 40,
                [mediaQueries.isTabletLandscape]: {
                    top: 40,
                    right: 40,
                }
            },
        }, {
            id: 2,
            location: "right",
            coloursObj: {
                triangleColour: "#6EE7B7",
                backgroundColor: "#10B981",
            },
            trianglePosition: "top-right",
            axisMultipliers: {
                x: 0.1,
                y: 0.4,
            },
        }, {
            id: 3,
            location: "left",
            coloursObj: {
                triangleColour: "#3B82F6",
                backgroundColor: "#1D4ED8",
            },
            trianglePosition: "bottom-left",
            axisMultipliers: {
                x: 0.3,
                y: 0.4,
            },
            styles: {
                position: "absolute",
                maxWidth: "1280px",
                top: 40,
                left: 120,

                [mediaQueries.isTabletLandscape]: {
                    top: 40,
                    left: 40,
                }
            },
        }
    ]


    return (
        <UseCasesPageTemplate
            page={workflow}
            theme="purple"
            imageSettings={imageSettings}
            location={location}
        />
    )
}

export default Workflow